import { useOutletContext } from 'react-router-dom';

export type PortalOutletCtx = {
  registryUrl: string;
  cdnUrl?: string;
  siteKey?: string;
  setSiteKey: (k: string | undefined) => void;
};

export const usePortalCtx = () => useOutletContext<PortalOutletCtx>();
